enum Screen {
  Deal,
  DealSelectProducts,
  DealPayment,
  DealRedemptionError,
  DealSuccess
}

export default Screen
